export const breakpoints = {
  0: 'mobile',
  1050: 'desktop',
};
